export function parseJwt(token) {
  if (!token) { return }
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace('-', '+').replace('_', '/')
  return JSON.parse(window.atob(base64))
}

export const handleLogError = (error) => {
  if (error.response) {
    console.log(error.response.data)
  } else if (error.request) {
    console.log(error.request)
  } else {
    console.log(error.message)
  }
}

/**
 * API 응답 데이터를 안전하게 검증
 */
export const safeApiResponse = (data, defaultValue = []) => {
  if (data === undefined || data === null) {
    console.warn('API 응답이 undefined 또는 null입니다. 기본값을 반환합니다.');
    return defaultValue;
  }
  return data;
}

/**
 * 배열 데이터를 안전하게 검증
 */
export const safeArray = (data, defaultValue = []) => {
  if (!Array.isArray(data)) {
    console.warn('데이터가 배열이 아닙니다. 빈 배열을 반환합니다.');
    return defaultValue;
  }
  return data;
}